import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Form
} from 'react-bootstrap';
import { Link } from 'react-router';
import i18n from 'kodyl-js/i18n/react';
import LoadingSpinner from '../loading-spinner';

const EMAIL_FAILED = 'This email is not registered.';
const PASSWORD_FAIL = 'This password is not correct.';
const EMAIL = 'email';
const PASSWORD = 'password';

class UserLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      loading: false,
      errMsg: null
    };
  }

  getErrMsg(obj) {
    const object = {
      [EMAIL_FAILED]: EMAIL,
      [PASSWORD_FAIL]: PASSWORD
    };

    if (obj && obj.info && obj.info.message) {
      return object[obj.info.message] || null;
    }
    return null;
  }

  handleSubmit = event => {
    const { login, prefs } = this.props;
    event.preventDefault();

    this.setState({ loading: true, error: null, errMsg: null }, () => {
      const email = ReactDOM.findDOMNode(this.email).value;
      const password = ReactDOM.findDOMNode(this.password).value;

      login({ email, password, prefs }).then(action => {
        if (action.error && action.error.statusCode === 401) {
          const {
            error: { response }
          } = action;
          this.setState({
            loading: false,
            error: true,
            errMsg: this.getErrMsg(response)
          });
        } else {
          this.setState({ loading: false });
        }

        return action;
      });
    });
  };

  render() {
    const { error, loading, errMsg } = this.state;

    return (
      <Form
        horizontal
        onSubmit={this.handleSubmit}
        autoComplete="on"
        className="form-glyph-left"
      >
        <div className="form-section">
          <FormGroup validationState={errMsg === EMAIL ? 'error' : null}>
            <Col componentClass={ControlLabel} sm={4}>
              {`${this.i18n('Email address')} *`}
            </Col>
            <Col sm={8}>
              <FormControl
                type="email"
                name="email"
                placeholder={this.i18n('Email address')}
                ref={ref => (this.email = ref)}
                required
              />
              <FormControl.Feedback />
            </Col>
          </FormGroup>
          <FormGroup validationState={errMsg === PASSWORD ? 'error' : null}>
            <Col componentClass={ControlLabel} sm={4}>
              {`${this.i18n('Password')} *`}
            </Col>
            <Col sm={8}>
              <FormControl
                type="password"
                name="password"
                placeholder={this.i18n('Password')}
                ref={ref => (this.password = ref)}
                required
              />
              <FormControl.Feedback />
            </Col>
          </FormGroup>
          {error && (
            <div
              className="alert alert-danger alert-last-dwelling"
              role="alert"
            >
              {this.i18n(
                'Adgangskode eller email-adresse er ikke korrekt. Prøv venligst igen eller tryk på "Glemt adgangskode"'
              )}
            </div>
          )}
          <Row className="form-group">
            <div className="col-sm-offset-4 col-sm-8 text-right">
              <Link to="/reset-password" className="btn">
                {this.i18n('Forgot password?')}
              </Link>
              &nbsp;&nbsp;&nbsp;
              <button
                type="submit"
                disabled={loading}
                className="btn btn-success"
              >
                <i className="fa fa-unlock" />
                {this.i18n('Login')}
              </button>
            </div>
          </Row>
          {loading ? <LoadingSpinner /> : null}
        </div>
      </Form>
    );
  }
}

export default i18n(UserLogin);
